


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { default as axios } from 'axios';
import { Utils } from '../../utils/utils';

@Component({
  components: {},
})
export default class Settings extends Vue {
  public drawer: boolean = false;

  public user: string = Utils.getCurrentUserName();
  public color: string = Utils.getCurrentUserColor();
  public loading: boolean = false;

  public css: string = '';

  constructor() {
    super();
    const body = document.body,
      html = document.documentElement;

    const height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight,
    );
    this.css = `height:${height}px;`;
  }

  updateColor() {
    this.drawer = false;

    axios
      .patch(`${process.env.VUE_APP_API_URL}/settings/users/${this.user}`, {
        color: this.color,
      })
      .then(response => {
        this.loading = true;

        window.location.reload();
      })
      .catch(err => {
        console.error(err);
      });
  }
}
